import React from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import LinearProgress from '@mui/material/LinearProgress';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function MessageDialog(props) {
    return (
        <div className="MessageDialog">
            <Dialog
                open={props.showMessageDialog}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" sx={{textAlign: "center" }}>
                    {props.label}
                </DialogTitle>
                    <DialogContent>
                        {props.Message!==null ?
                            <DialogContentText color="primary" sx={{textAlign: "center" }}>
                                {props.Message}
                            </DialogContentText>
                        :    
                            props.progressType !== null ?
                                <LinearProgress variant={props.progressType} value={props.progress} />
                            :
                                <LinearProgress />
                        }
                    </DialogContent>
                <DialogActions>
                    {props.Message!==null &&
                        <Button autoFocus onClick={()=>props.onCloseMessageDialog()} sx={{textAlign: "center" }}>
                            OK
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
}
